import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
const { REQUEST_GET_ALL_TEMPLATES, SUCCESS_GET_ALL_TEMPLATES, FAILURE_GET_ALL_TEMPLATES } =
  documentationActions;

function* getAllTemplates(action: any): SagaReturnType<any> {
  try {
    const response = yield call(templateService.getAllTemplates, action.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_GET_ALL_TEMPLATES, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_ALL_TEMPLATES, payload: error });
  }
}

function* getAllTemplatesSaga() {
  yield takeEvery(REQUEST_GET_ALL_TEMPLATES, getAllTemplates);
}

export default getAllTemplatesSaga;
